export const filenameFromKey = (key: string) => {
  const split = key.split("/");
  return split.at(-1);
};
